// extracted by mini-css-extract-plugin
export default {"root":"DateString_root__mhXzC"};